import { useAccountModalDispatch } from 'account/hooks/useAccountModal';
import { AccountModalActions } from 'account/state/accountModalReducer';

export const useLogInBeforeCheckout = () => {
  const accountModalDispatch = useAccountModalDispatch();

  const logInBeforeCheckout = (redirectLink) => {
    accountModalDispatch({ type: AccountModalActions.openLogInModal });
    accountModalDispatch({
      type: AccountModalActions.redirect,
      payload: redirectLink,
    });
    accountModalDispatch({
      type: AccountModalActions.setButtonText,
      payload: 'Proceed to Checkout',
    });
    accountModalDispatch({
      type: AccountModalActions.setTitle,
      payload: 'Log In to Continue',
    });
  };

  return { logInBeforeCheckout };
};
